import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDecisionById } from 'components/Experiment/useDecisionById';
import { ChevronRightBold } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { EOS_OFFERS_TEXT } from 'constants/monetateExperiments';

import styles from 'components/Product/Promotion/Description/PromotionDescription.scss';

const SimplePromotionDescription = ({
  description,
  underlineText,
  noMargin,
  backgroundColor,
  isLink,
  withChevron,
  promotion,
}) => {
  const { promotionId } = promotion || {};
  const { variant, payload: promotionsIds } = useDecisionById(EOS_OFFERS_TEXT.experiment);

  let descriptionWithExperiment = description;

  if (promotionsIds?.includes(promotionId)) {
    switch (variant) {
      case EOS_OFFERS_TEXT.variant.phase1:
        descriptionWithExperiment = `Any ${description.substring(3)}`;
        break;
      case EOS_OFFERS_TEXT.variant.phase2:
        descriptionWithExperiment = `Any ${description.substring(3)} Mix & Match`;
        break;
      default:
        break;
    }
  }

  return (
    <p
      className={classNames(styles.offerDescription, {
        [styles.noMargin]: noMargin,
        [styles.withBackground]: !!backgroundColor,
        [styles.green]: backgroundColor === 'green',
      })}
    >
      <span data-testid="description" className={classNames({ [styles.underline]: underlineText })}>
        {descriptionWithExperiment}
      </span>
      {backgroundColor && isLink && withChevron && (
        <ChevronRightBold size="xsmall" className={styles.chevronIcon} />
      )}
    </p>
  );
};

SimplePromotionDescription.displayName = 'SimplePromotionDescription';

SimplePromotionDescription.propTypes = {
  description: PropTypes.string.isRequired,
  underlineText: PropTypes.bool,
  noMargin: PropTypes.bool,
  backgroundColor: PropTypes.string,
  isLink: PropTypes.bool,
  withChevron: PropTypes.bool,
  promotion: PropTypes.shape({
    myWaitrosePromotion: PropTypes.bool,
    promotionDescription: PropTypes.string,
    promotionExpiryDate: PropTypes.string,
    promotionId: PropTypes.number,
    promotionTypeCode: PropTypes.string,
    wasDisplayPrice: PropTypes.string,
    groups: [
      {
        lineNumbers: PropTypes.arrayOf(PropTypes.string),
        name: PropTypes.string,
        threshold: PropTypes.number,
      },
    ],
  }),
};
SimplePromotionDescription.defaultProps = {
  underlineText: false,
  noMargin: false,
  isLink: false,
  backgroundColor: undefined,
  withChevron: false,
  promotion: undefined,
};

export default memo(SimplePromotionDescription);
